import { forwardRef } from "react";
import {
  Button,
  ModalContent,
  ModalProps,
  createModalComponent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
  DialogClose,
} from "@shortsworks/ui";

interface CommonErrorModalProps {
  title: string;
  description: string;
}

const CommonErrorModalContent = (props: ModalProps<CommonErrorModalProps>) => {
  const title = props.title ?? "일시적으로 문제가 발생했습니다.";

  return (
    <ModalContent>
      <DialogHeader>
        <DialogTitle>{title}</DialogTitle>
        <DialogDescription>{props.description}</DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <DialogClose asChild></DialogClose>
        <Button
          onClick={() => props.close({ value: undefined })}
          className="p-0 w-full md:w-[104px] h-[40px]"
        >
          확인
        </Button>
      </DialogFooter>
    </ModalContent>
  );
};

export const CommonErrorModal = createModalComponent(CommonErrorModalContent);
